"use client";
export { AnimateNumber } from './components/AnimateNumber.mjs';
